import App from './App.vue'
import router from './router'
import plugins from './plugins'
import axios from './plugins/axios'
import toast from './plugins/toastification'
import store from "./store";
import { createApp } from 'vue'

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "@/assets/css/app.css"
import "@/assets/css/responsive.css"
import "@/assets/css/fonts.css";
import "@/assets/css/fontawesome/css/fontawesome.css";
import "@/assets/css/fontawesome/css/solid.css";

import clickOutside from "./directives/clickOutside";

export const app = createApp(App)

app.use(router)
app.use(plugins)
app.use(axios)
app.use(toast)
app.use(store);

app.directive("click-outside", clickOutside);

app.mount("#app")
